import { useSearchParams } from 'react-router-dom';

export function useReqIdParam() {
  const [searchParams] = useSearchParams();
  const reqidParam = searchParams.get('reqId');
  return reqidParam;
}
